/**
 * API Keys Contract — typed API contract for workspace-scoped API key management.
 *
 * All types derived from generated Zod schemas (OpenAPI-first).
 * Maps to: core/app/schemas/api_key.py
 */

import { z } from 'zod';

import {
  zApiKeyCreate as GeneratedApiKeyCreate,
  zApiKeyCreated as GeneratedApiKeyCreated,
  zApiKeyRead as GeneratedApiKeyRead,
  zApiKeyList as GeneratedApiKeyList,
} from '@/api/generated/hey-api/zod.gen';

// ─── Schemas ────────────────────────────────────────────────────────────────

export const ApiKeyCreateSchema = GeneratedApiKeyCreate;
export type ApiKeyCreate = z.infer<typeof ApiKeyCreateSchema>;

export const ApiKeyCreatedSchema = GeneratedApiKeyCreated;
export type ApiKeyCreated = z.infer<typeof ApiKeyCreatedSchema>;

export const ApiKeyReadSchema = GeneratedApiKeyRead;
export type ApiKeyRead = z.infer<typeof ApiKeyReadSchema>;

export const ApiKeyListSchema = GeneratedApiKeyList;
export type ApiKeyList = z.infer<typeof ApiKeyListSchema>;
